import { DRAWING_FEATURE } from "../../../../MapStore2/web/client/actions/draw";
import { geometryChangedAction } from "./geometryChangedAction";
import { EpicFactory } from "../../../core/core-redux/reduxTypes";
import { RootState } from "../../../rootState";
import { Feature } from "../../../core/geo/types";
import { isGeometryCollection } from "../../../core/geo/assertions";
import { geometryChangeRetrievers } from "../../util/geometry/geometryChangeRetriever";
import { ChangeTypes, GeometryChange } from "../../util/geometry/types";
import { insertFeatureAction } from "../insertFeature";
import { updateFeatureAction } from "../updateFeature";

export const geometryChangedEpic: EpicFactory<{ type: string; features: Feature[] }, RootState, any> = (
    action,
    store
) =>
    action.ofType(DRAWING_FEATURE).switchMap((action) => {
        const isDevelopmentMode = store.getState().urlParams.developmentMode;
        const editFeature = store.getState().editFeature;
        const projection = store.getState().map?.present?.projection;
        const changeRetriever = geometryChangeRetrievers[action.features[0].geometry.type];
        const editedFeatures = action.features;

        const featuresBefore = editFeature?.editedFeatures?.features;
        const actions = [];

        for (const index in editedFeatures) {
            const featureNow = editedFeatures[index];
            const featureBefore = featuresBefore?.filter(
                (feature) => feature.properties.id === featureNow.properties.id
            )[0];
            const geometryChanges = changeRetriever?.retrieveChange(
                featureBefore,
                featureNow,
                editFeature?.options!,
                projection
            );
            if (geometryChanges?.some((geometryChange) => geometryChange?.type !== ChangeTypes.NONE)) {
                if (isGeometryCollection(featureBefore?.geometry)) {
                    if (featureBefore!.geometry.geometries.length > 0) {
                        actions.push(updateFeatureAction(featureBefore!.id, featureNow));
                    } else {
                        actions.push(insertFeatureAction(featureNow));
                    }
                    actions.push(
                        geometryChangedAction(
                            geometryChanges!,
                            featureNow,
                            !isDevelopmentMode && shouldWaitForPortal(geometryChanges!)
                        )
                    );
                    return actions;
                }

                if (featureBefore) {
                    actions.push(updateFeatureAction(featureBefore.id, featureNow));
                } else {
                    actions.push(insertFeatureAction(featureNow));
                }
                actions.push(
                    geometryChangedAction(
                        geometryChanges!,
                        featureNow,
                        !isDevelopmentMode && shouldWaitForPortal(geometryChanges!)
                    )
                );
            }
        }
        return actions;
    });

const shouldWaitForPortal = (changes: GeometryChange[]) => {
    return changes.some(
        (change) =>
            change.type === ChangeTypes.ADD_LINE_POINT ||
            change.type === ChangeTypes.REMOVE_LINE_POINT ||
            change.type === ChangeTypes.ADD_POLYGON_POINT ||
            change.type === ChangeTypes.REMOVE_POLYGON_POINT ||
            change.type === ChangeTypes.INSERT_LINE ||
            change.type === ChangeTypes.INSERT_POINT ||
            change.type === ChangeTypes.INSERT_POLYGON ||
            change.type === ChangeTypes.INSERT_CIRCLE ||
            change.type === ChangeTypes.SEGMENT_CHANGED
    );
};
